import { StyleSheet } from 'react-native'
import { grayBorders, white, toqueColor, corporateColor } from '../../theme/colors'
import { DOBRA } from '../../theme/fonts'

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    margin: 10,
    marginHorizontal: 0,
  },

  checkContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },

  check: {
    width: 25,
    height: 25,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: grayBorders,
    backgroundColor: white,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },

  checkActive: {
    borderColor: toqueColor,
    backgroundColor: toqueColor,
  },

  label: {
    fontSize: 16,
    color: corporateColor,
    fontWeight: '600',
    fontFamily: DOBRA,
  },
})
